import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { PATHS } from "@constants/Paths";
import { useAuthContext } from "@stores/AuthContext";
export const AuthLayout = () => {
    const { onLogin, user } = useAuthContext();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const tokenFromSearch = searchParams.get("token");
    useEffect(() => {
        if (!tokenFromSearch)
            return;
        onLogin({ token: tokenFromSearch }, true);
    }, [onLogin, tokenFromSearch]);
    if (tokenFromSearch && !user) {
        return null;
    }
    if (!user) {
        return React.createElement(Navigate, { to: PATHS.LOGIN, replace: true, state: { redirectTo: location } });
    }
    return React.createElement(Outlet, null);
};
export default AuthLayout;
